import styled from 'styled-components';

export const StyledField = styled.div`
    display: flex;
    gap: 5px;
    align-items: center;

    .gi-input {
        display: flex;
    }

    .gi-DROPDOWN {
        width: 100% !important;
    }
`;

export const StyledFooterContainer = styled.div`
    display: flex;
    justify-content: end;
    align-items: center;
    gap: 1rem;

    .gi-checkbox__label {
        display: flex;
        gap: 2rem;
        align-items: center;
        margin: 0;
    }
`;

export const StyledMainSection = styled.div<{ hasNoPadding: boolean }>`
    padding: ${(hasNoPadding) => hasNoPadding ? '0' : '24px 24px 32px 24px'};
`;

export const StyledCheckboxField = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;

    .gi-input__label,
    .gi-checkbox__input {
        margin: 0;
        cursor: pointer;
    }
`;
